<template>
  <div class="container">
    <h1>Join the Secure Secrets Community!</h1>
    <div class="socialMediaContainer">
      <CommunityIconButton
        v-for="(linkObject, index) in linkData"
        :key="index"
        :linkData="linkObject"
      />
    </div>
  </div>
</template>
<script>
import CommunityIconButton from "@/components/CommunityIconButton";
export default {
  metaInfo: {
    title: "Community",
    meta: [
      {
        name: "description",
        content:
          "Join the Secure Secrets community on social media and help us make an impact in Secret Network ecosystem where we serve as a blockchain validator.",
      },
    ],
  },
  components: {
    CommunityIconButton,
  },
  name: "community-view",
  data: () => ({
    linkData: [
      {
        path: "https://www.youtube.com/c/SecureSecrets",
        symbol: "fab fa-youtube fa-7x",
      },
      {
        path: "https://twitter.com/securesecrets",
        symbol: "fab fa-twitter fa-7x",
      },
      {
        path: "https://t.me/securesecrets",
        symbol: "fab fa-telegram fa-7x",
      },
      {
        path: "https://www.linkedin.com/company/securesecrets",
        symbol: "fab fa-linkedin fa-7x",
      },
      {
        path: "https://discord.gg/tXj3tCH5",
        symbol: "fab fa-discord fa-7x",
      },
      {
        path: "https://securesecrets-org.medium.com/",
        symbol: "fab fa-medium fa-7x",
      },
    ],
  }),
};
</script>
<style scoped>
.container {
  min-height: calc(100vh - 75px);
}

h1 {
  margin-top: 50px;
  margin-bottom: 20px;
}

.socialMediaContainer {
  margin: 0 auto;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
</style>
